
/* styles */
require("!!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-0ff94af4\",\"scoped\":true,\"hasInlineConfig\":false}!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./AppLoader.scp.html")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!!../../../node_modules/vue-loader/lib/selector?type=script&index=0!./AppLoader.scp.html"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0ff94af4\"}!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./AppLoader.scp.html"),
  /* scopeId */
  "data-v-0ff94af4",
  /* cssModules */
  null
)
Component.options.__file = "C:\\Products\\VCare\\Sourcecode\\branches\\UAT\\VCarePortal\\PharmacyPortal\\ClientApp\\components\\AppLoader\\AppLoader.scp.html"
if (Component.esModule && Object.keys(Component.esModule).some(function (key) {return key !== "default" && key !== "__esModule"})) {console.error("named exports are not supported in *.vue files.")}
if (Component.options.functional) {console.error("[vue-loader] AppLoader.scp.html: functional components are not supported with templates, they should use render functions.")}

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-0ff94af4", Component.options)
  } else {
    hotAPI.reload("data-v-0ff94af4", Component.options)
  }
})()}

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./ClientApp/components/AppLoader/AppLoader.scp.html
// module id = 233
// module chunks = 0